import * as React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import { TTranslate } from "../../../../service/locale/TranslationService";
import Report7PDFTemplate from "./Report7PDFTemplate";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";

const Report7PDFExportLink = ({
  translate,
  report7Data,
  fileName,
  selectedReportingPeriod
}: {
  translate: TTranslate;
  report7Data: IReport7ApplicantPresentationModel[];
  fileName: string;
  selectedReportingPeriod?: IReportingPeriodItem;
}) => {
  return (
    <PDFDownloadLink
      document={
        <Report7PDFTemplate
          selectedReportingPeriod={selectedReportingPeriod}
          translate={translate}
          applicants={report7Data}
        />
      }
      fileName={fileName}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default Report7PDFExportLink;
